import * as ACTIONS from './constants';

// services
import { getBasketsForUser } from '../services/basketService';
import { equal } from '../services/jsonEqualityService';

export const getBasketsforUser = () => (dispatch, getState) => {
  const state = getState();
  const { userGuid, userId } = state.user;
  return getBasketsForUser(userGuid, userId)
  .then((payload) => {
    if(!equal(payload, state.baskets.baskets, { ignoreArrayOrder: true })) {
      dispatch({ type: ACTIONS.UPDATE_BASKETS, payload });
    }
  });
};




// WEBPACK FOOTER //
// ./src/actions/baskets.js